<template>
    <div>
        <b-modal
            dialog-class="email-conversation-modal"
            hide-footer
            title=""
            :visible="show && conversationId !== null"
            @hidden="$emit('hidden')">
            <csp-digital-mailbox-email-list-table
                v-if="conversationId !== null"
                :items-ajax-url="itemsAjaxUrl"
                table-headline="E-Mail-Konversation"
                @row-clicked="onRowClicked">
                <template v-slot:cell(actions)="{ data }">
                    <div class="table-actions">
                        <a
                            v-if="data.actions.attachmentCount"
                            title="Anhänge anzeigen"
                            @click.stop="openAttachmentModal(data.actions.emailId)">
                            <i class="inticon-autoclaim_files"/>
                        </a>
                    </div>
                </template>
            </csp-digital-mailbox-email-list-table>
        </b-modal>

        <csp-email-attachment-modal
            :email-id="attachmentModalEmailId"
            :show="showAttachmentModal"
            @hidden="onAttachmentModalHidden"/>
    </div>
</template>

<script>
import EmailAttachmentModal from '@desktop/components/digital-mailbox/EmailAttachmentModal.vue';
import EmailListTable from '@desktop/components/digital-mailbox/EmailListTable.vue';

export default {
    components: {
        'csp-digital-mailbox-email-list-table': EmailListTable,
        'csp-email-attachment-modal': EmailAttachmentModal,
    },
    props: {
        conversationId: {
            default: null,
            type: String,
        },
        show: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            attachmentModalEmailId: null,
            showAttachmentModal: false,
        };
    },
    computed: {
        itemsAjaxUrl() {
            if (this.conversationId === null) {
                return '';
            }
            return '/api/desktop/digital-mailbox/conversations/emails?conversationId='
                + encodeURIComponent(this.conversationId);
        },
    },
    methods: {
        onAttachmentModalHidden() {
            this.showAttachmentModal = false;
        },
        onRowClicked(item) {
            this.$emit('open-email', item);
        },
        openAttachmentModal(emailId) {
            this.attachmentModalEmailId = emailId;
            this.showAttachmentModal = true;
        },
    },
};
</script>
